<template>
  <div>
    <!-- <el-button class="clear" @click="clickClear">クリア</el-button> -->
    <el-button type="primary" class="import" @click="clickImport">取込</el-button>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
  },
  data () {
    return {}
  },
  methods: {
    clickImport () {
      this.$emit('import')
    }
  }
}
</script>

<style lang="scss" scoped>
.clear,
.import {
  width: 8em;
}
</style>
